import * as React from 'react';
import {useFormikContext} from 'formik';
import Row from 'components/Row';
import Column from 'components/Column';
import FormContainer from '../../containers/FormContainer';
import {WebinarObject} from 'api/webinar/types';
import Upload from '../../../../Upload';
import {FileObject, FileType} from '../../../../../api/library';
import {Document} from '../../../../LessonViewer/components/Content/templates';
import TextEditor from '../../../../TextEditor';

/**
 * The prepare message form part
 * @return {React.ReactElement}
 * @constructor
 */
export default function PrepareMessageForm(): React.ReactElement {
  const formContext = useFormikContext<Partial<WebinarObject>>();

  /**
   * The select event handler.
   * @param {string} value
   */
  function handleChange(value: string): void {
    formContext.setFieldValue('prepareMessage.text', value);
    formContext.submitForm();
  }

  return (
    <FormContainer
      property="prepareMessage"
      label="Подготовка к трансляции"
      collapse
    >
      <Row>
        <Column>
          <Row>
            <Column>
              <TextEditor
                defaultValue={formContext.values?.prepareMessage?.text}
                onChange={handleChange}
              />
            </Column>
          </Row>
        </Column>
      </Row>
    </FormContainer>
  );
}
